import React from "react";
import "./Skills.css";
import SkillSection from "./SkillSection";
import { Fade } from "react-reveal";
import { useLanguage } from "../../context/LanguageContext";
import translations from "../../i18n/translations";

export default function Skills(props) {
  const theme = props.theme;
  const { lang } = useLanguage();
  const t = translations[lang];

  return (
    <div className="main" id="skills">
      <div className="skills-header-div">
        <Fade bottom opposite duration={2000} distance="20px">
          <h1 className="skills-header" style={{ color: theme.text }}>
            {t.skills.header}
          </h1>
        </Fade>
      </div>
      <SkillSection theme={theme} />
    </div>
  );
}
